const {
  pushAnalyticsObjToDataLayer,
  getAnalyticLinkUrl,
} = require("@/utils/helper")

export const orderDetailsAnalytics = (orderType = "open", url) => {
  const eventInfo = {
    clickInternalLinks: "true",
    eventAction: `my account:orders:${orderType} orders:order details`,
    eventName: `my account:orders:${orderType} orders:order details`,
    eventType: "navigation",
    internalLinkName: "order details",
    internalLinkPosition: "my account",
    internalLinkType: "my account:submitted",
    internalLinkZoneName: `my account:orders:${orderType} orders`,
    internalLinkURL: getAnalyticLinkUrl(url),
  }
  return JSON.stringify(eventInfo)
}
export const continueAnalytics = url => {
  const eventInfo = {
    clickInternalLinks: "true",
    eventAction: "my account:orders:continue shopping",
    eventName: "my account:orders:continue shopping",
    eventType: "navigation",
    internalLinkName: "continue shopping",
    internalLinkPosition: "my order",
    internalLinkType: "my account:navigation",
    internalLinkZoneName: "my account:orders:open orders",
    internalLinkURL: url
      ? url.indexOf("http") === -1
        ? window.location.origin
        : ""
      : "n/a",
  }
  pushAnalyticsObjToDataLayer(eventInfo)
}
export const orderSignOutAnalytics = () => {
  const eventInfo = {
    clickInternalLinks: "true",
    eventAction: "my account:orders:sign out",
    eventName: "my account:orders:sign out",
    eventType: "navigation",
    internalLinkName: "sign out",
    internalLinkPosition: "my account",
    internalLinkType: "my account:navigation",
    internalLinkZoneName: "my account:orders",
    internalLinkURL: "n/a",
  }
  pushAnalyticsObjToDataLayer(eventInfo)
}

export const loadMoreAnalytics = (orderType = "open") => {
  const eventInfo = {
    clickInternalLinks: "true",
    eventAction: `my account:orders:${orderType} orders:load more`,
    eventName: `my account:orders:${orderType} orders:load more`,
    eventType: "navigation",
    internalLinkName: "load more",
    internalLinkPosition: "my account",
    internalLinkType: "my account:navigation",
    internalLinkZoneName: `my account:orders:${orderType} orders`,
    internalLinkURL: "n/a",
  }
  pushAnalyticsObjToDataLayer(eventInfo)
}

export const orderBackToTopAnalytics = (orderType = "open") => {
  const eventInfo = {
    clickInternalLinks: "true",
    eventAction: `my account:orders:${orderType} orders:back to top`,
    eventName: `my account:orders:${orderType} orders:back to top`,
    eventType: "navigation",
    internalLinkName: "back to top",
    internalLinkPosition: "my account",
    internalLinkType: "my account:navigation",
    internalLinkZoneName: `my account:orders:${orderType} orders`,
    internalLinkURL: "n/a",
  }
  return JSON.stringify(eventInfo)
}

export const orderPaginationAnalytics = (orderType = "open", count = "") => {
  const eventInfo = {
    clickInternalLinks: "true",
    eventAction: `my account:orders:${orderType} orders:pagination`,
    eventName: `my account:orders:${orderType} orders:pagination`,
    eventType: "navigation",
    internalLinkName: count,
    internalLinkPosition: "my account",
    internalLinkType: "my account:pagination bottom",
    internalLinkZoneName: `my account:orders:${orderType} orders`,
    internalLinkURL: "n/a",
  }
  return JSON.stringify(eventInfo)
}
